module.exports = __webpack_public_path__ + "img/blue.5e67ae8e.jpg";